<script>
export default {
  props: ["clr", "strokeWidth", "fill"]
};
</script>

<template>
  <svg
    id="checkmark-circle-1"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g id="Group_964" data-name="Group 964" transform="translate(2.75 2.75)">
      <path
        id="Path_8344"
        data-name="Path 8344"
        d="M11.25,3a8.25,8.25,0,1,0,8.25,8.25A8.25,8.25,0,0,0,11.25,3Z"
        transform="translate(-3 -3)"
        :fill="fill ? fill : 'none'"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        :stroke-width="strokeWidth ? strokeWidth : 1.5"
      />
      <path
        id="Path_8345"
        data-name="Path 8345"
        d="M8.44,12.11,10.426,14.1l-.018-.018L14.881,9.6"
        transform="translate(-3.453 -3.55)"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8346" data-name="Path 8346" d="M0,0H22V22H0Z" fill="none" />
  </svg>
</template>
